import { takeEvery, put, call } from "redux-saga/effects";
import {
  GET_ORDER_VEHICLE_LIST,
  ADD_ORDER_VEHICLE,
  EDIT_ORDER_VEHICLE,
  DELETE_ORDER_VEHICLE,
} from './actionTypes';

import {
  getOrderVehicleListOk,
  getOrderVehicleListErr,
  addOrderVehicleOk,
  addOrderVehicleErr,
  editOrderVehicleOk,
  editOrderVehicleErr,
  deleteOrderVehicleOk,
  deleteOrderVehicleErr,
} from './actions';

import {
  getOrderVehicles,
  editOrderVehicle,
  addOrderVehicle,
  deleteOrderVehicle,
} from '~/helpers/backendHelper';

/********** LIST **********/

function* onGetOrderVehicleList(action) {
  try {
    const { orderId } = action.payload;
    const response = yield call(getOrderVehicles, orderId);
    yield put(getOrderVehicleListOk(response));
  } catch (error) {
    yield put(getOrderVehicleListErr(error));
  }
}

/********** ADD **********/

function* onAddOrderVehicle(action) {
  try {
    const { orderId, vehicleData } = action.payload;
    const response = yield call(addOrderVehicle, orderId, vehicleData);
    yield put(addOrderVehicleOk(response));
  } catch (error) {
    yield put(addOrderVehicleErr(error));
  }
}

/********** UPDATE  **********/

function* onUpdateOrderVehicle(action) {
  try {
    const { vehicleId, vehicleData } = action.payload;
    const response = yield call(editOrderVehicle, vehicleId, vehicleData);
    yield put(editOrderVehicleOk(response));
  } catch (error) {
    yield put(editOrderVehicleErr(error));
  }
}
/********** DELETE - Real implementation **********/

function* onDeleteOrderVehicle(action) {
  try {
    const { vehicleId } = action.payload;
    const response = yield call(deleteOrderVehicle, vehicleId);
    yield put(deleteOrderVehicleOk(response));
  } catch (error) {
    yield put(deleteOrderVehicleErr(error));
  }
}

/********** MAIN SAGA **********/

function* orderVehiclesSaga() {
  yield takeEvery(GET_ORDER_VEHICLE_LIST, onGetOrderVehicleList);
  yield takeEvery(ADD_ORDER_VEHICLE, onAddOrderVehicle);
  yield takeEvery(EDIT_ORDER_VEHICLE, onUpdateOrderVehicle);
  yield takeEvery(DELETE_ORDER_VEHICLE, onDeleteOrderVehicle);
}

export default orderVehiclesSaga;